import * as a from './constants'

export const updateEthereumLastBlock = (blockchain, block) => ({
  type: a.ETHEREUM_LAST_BLOCK,
  blockchain,
  block,
})
